module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userHasPermissionToEdit) ? _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onPresenceClickaway),
      expression: "onPresenceClickaway"
    }],
    staticClass: "user-presence inline-block",
    class: [{
      'user-presence__modal-left': _vm.isModalLeft
    }, {
      'user-presence__multiple-users': !_vm.calid
    }]
  }, [_c('button', {
    staticClass: "up__button no-print",
    class: {
      'do-bttn': _vm.activeCalendarDate
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('vue2.presence.work_hours')) + "\n    "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInDown"
    }
  }, [(_vm.modal) ? _c('div', {
    staticClass: "up-modal text-dark"
  }, [_c('div', {
    staticClass: "up-modal__header"
  }, [_c('h2', {
    staticClass: "text-blue"
  }, [(!_vm.showWeekSelector) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.set_work_hours')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.choose_weeks_for_work_hours')))])]), _vm._v(" "), (!_vm.showWeekSelector && _vm.calid) ? _c('div', {
    staticClass: "hint--left",
    attrs: {
      "aria-label": _vm.$t('vue2.presence.edit_default_times')
    }
  }, [_c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": _vm.openDefaultTimesSettings
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "up-modal__content",
    class: {
      'showweeks': _vm.showWeekSelector
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_c('Spinner', {
    attrs: {
      "color": "blue"
    }
  })], 1) : _c('div', {
    staticClass: "up-modal__content-slider",
    class: {
      'showweeks': _vm.showWeekSelector
    }
  }, [_c('div', {
    class: {
      'up-modal__content-slider--weekend-with-hours': _vm.hasWeekendEvents && !_vm.showWeekSelector
    }
  }, [_c('div', {
    staticClass: "flex-table user-presence__table"
  }, [_c('div', {
    staticClass: "flex-tr flex-tr__header"
  }, [_c('div', {
    staticClass: "flex-td"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-td"
  }, [_c('span', {
    staticClass: "text-normal"
  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.work_hours_in_the_week')) + ":")]), _vm._v("\n                  " + _vm._s(_vm.durationAsHoursAndMin(_vm.totalDurationWeek)) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.weekDays), function(weekDay) {
    return _c('div', {
      staticClass: "flex-tr tr-weekdays-hours"
    }, [_c('div', {
      staticClass: "flex-td flex-1 capitalize user-presence__table__first"
    }, [_c('div', {
      staticClass: "flex-td"
    }, [_vm._v("\n                    " + _vm._s(_vm.$filters.dddd(weekDay)) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "flex-td"
    }, [_c('button', {
      class: {
        'inactive': _vm.lastEventOfDayIsCloseToMidnight(weekDay)
      },
      on: {
        "click": function($event) {
          return _vm.addEvent(weekDay)
        }
      }
    }, [_c('span', [_vm._v("+")])])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-td flex-3 time-changer"
    }, [_vm._l((_vm.events), function(event) {
      return [(_vm.compareDates(event.start, weekDay)) ? [_c('EditEvent', {
        key: event.id,
        attrs: {
          "event": event
        },
        on: {
          "updateStart": _vm.updateStart,
          "updateEnd": _vm.updateEnd,
          "delete": _vm.deleteEvent,
          "duration": _vm.setEventDurations
        }
      })] : _vm._e()]
    })], 2)])
  })], 2)]), _vm._v(" "), _c('div', [_c('WeekPicker', {
    attrs: {
      "date": _vm.activeCalendarDate,
      "calid": _vm.calid
    },
    on: {
      "weeks": _vm.setPastedWeeks,
      "isWithinCalRange": _vm.setCurrentDateIsNotWithinCalendarRange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "up-modal__footer"
  }, [_c('button', {
    staticClass: "bg-white",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.presence.cancel')) + "\n        ")]), _vm._v(" "), _c('div', [(_vm.intersections.length < 1) ? _c('div', [(!_vm.currentDateIsNotWithinCalendarRange) ? [_c('button', {
    on: {
      "click": function($event) {
        _vm.showWeekSelector = !_vm.showWeekSelector
      }
    }
  }, [(!_vm.showWeekSelector) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.copy_to_multiple_weeks')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.presence.back')))])])] : _vm._e(), _vm._v(" "), (_vm.calid || _vm.pasteInWeeks.length > 0) ? _c('button', {
    staticClass: "bg-white",
    class: {
      'bttn-passive': true
    },
    on: {
      "click": _vm.savePresence
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.presence.save')) + "\n            ")]) : _vm._e()], 2) : _c('div', [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('vue2.presence.times_may_not_overlap')))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.isShowSettings) ? _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": _vm.closeDefaultTimesSettings
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.presence.default_work_hours')))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": _vm.closeDefaultTimesSettings
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content text-dark"
  }, [_c('label', {
    staticClass: "d-input marg-1-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.standard_settings.set_default_start_and_endtime')))]), _vm._v(" "), _c('div', {
    staticClass: "d-input-group-flex"
  }, [_c('TimeChanger', {
    attrs: {
      "addClass": "presence-default-times",
      "showIcon": true,
      "inputWidth": 80,
      "start": _vm.standardStartTime,
      "end": _vm.standardEndTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStandardStartTime,
      "updateEnd": _vm.setStandardEndTime
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn bttn-simple marg-1-right",
    on: {
      "click": _vm.closeDefaultTimesSettings
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.submitStandardSettings
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aef65da6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Presence/User/PresenceUser.vue
// module id = 2089
// module chunks = 1